import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

import syncNested from './syncNested.vue'

@Component({ name:"sync-nested", components: { syncNested } })
export default class SyncNested extends Vue {
    @Prop({required: true})
    public value: StepCall[];

    @Prop({required: true})
    public item: StepCall;
}
